'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var attachPendo = require('./attach-pendo.js');

/* eslint-disable no-unused-expressions */
var PendoTracker = function (_a) {
    var pendoApiKey = _a.pendoApiKey, zendeskApiKey = _a.zendeskApiKey, visitor = _a.visitor, account = _a.account, logger = _a.logger;
    React__default.useEffect(function () {
        var cleanupFn = function () { };
        if (zendeskApiKey && pendoApiKey) {
            var _a = attachPendo.attachPendoWithZendesk(pendoApiKey, zendeskApiKey), pendoScriptEl_1 = _a[0], zendeskScriptEl_1 = _a[1];
            logger === null || logger === void 0 ? void 0 : logger('Pendo script attached to DOM');
            if (pendoScriptEl_1 && zendeskScriptEl_1) {
                window.pendo.initialize({ visitor: visitor, account: account });
                logger === null || logger === void 0 ? void 0 : logger('Pendo initialized with: ', { visitor: visitor, account: account });
                cleanupFn = function () {
                    pendoScriptEl_1.remove();
                    zendeskScriptEl_1.remove();
                    delete window.pendo;
                    delete window.zE;
                    logger === null || logger === void 0 ? void 0 : logger('Pendo removed');
                };
            }
        }
        return cleanupFn;
    }, [pendoApiKey, zendeskApiKey]);
    return null;
};

module.exports = PendoTracker;
